import { render } from "./refuelingCard.vue?vue&type=template&id=2ed8a55c&scoped=true"
import script from "./refuelingCard.vue?vue&type=script&lang=js"
export * from "./refuelingCard.vue?vue&type=script&lang=js"

import "./refuelingCard.vue?vue&type=style&index=0&id=2ed8a55c&lang=less&scoped=scoped"

import exportComponent from "/data/spug/spug_api/repos/34_1470_20220520214630/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed8a55c"]])

export default __exports__